<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="icon_infos">
      <div class="info_lefts" style="min-width: 400px">
        <template v-if="info.number">
          <div class="item_box active_Info_name">
            <div class="top_head">
              <img :src="info.head"/>
            </div>
            <div class="box_info_infos">
              <div>{{ info.name }}({{ info.number }})</div>
              <div>{{ info.org ? info.org.name : '' }} / {{ info.post ? info.post.name : '' }}</div>
            </div>
          </div>
          <div @click="goInfo" v-if="salesTransactionInfo.sysver" class="item_box"
               style="display: flex;justify-content: space-between;align-items: center">
            <div class="name_tabs">系统版本：{{ salesTransactionInfo.sysver ? salesTransactionInfo.sysver.verid : '' }}</div>
            <div style="width: 100px;height: 20px;display: flex;align-items: center;justify-content: flex-end"><span
                class="bor_yas">{{
                salesTransactionInfo.sysver ? salesTransactionInfo.sysver.verStatusName : ''
              }}</span><i
                style="font-size: 25px;color: #959595" class="el-icon-arrow-right"></i></div>
          </div>
          <div class="item_box" v-if="salesTransactionInfo.appInfos">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div> 我的应用 <span style="margin-left:5px;">（{{ salesTransactionInfo.appInfos.length }}）</span></div>
              <div :class="{'active_box':changAppNum>10,'nowMore':changAppNum<=10}" @click="changNums">
                <i v-if="salesTransactionInfo.appInfos.length>10" style="font-size: 25px;color: #959595"
                   class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="info_list_tabs">
              <div class="info_item" v-for="(item,index) in salesTransactionInfo.appInfos.slice(0,changAppNum)">
                <div class="left_box">
                  <img :src="item.appLogo">
                </div>
                <el-tooltip class="item" effect="dark" :content="item.appName" placement="top-start">
                  <div class="right_infos">
                    <div>{{ item.appName }}</div>
                    <div>swid：{{ item.swid }}</div>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="item_box" v-if="salesTransactionInfo.channelAccounts">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div> 我的渠道账号 <span style="margin-left:5px;">（{{ salesTransactionInfo.channelAccounts.length }}）</span>
              </div>
              <div :class="{'active_box':accountsNum>10,'nowMore':accountsNum<=10}" @click="changSceNums">
                <i v-if="salesTransactionInfo.channelAccounts.length>10" style="font-size: 25px;color: #959595"
                   class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="info_list_tabs">
              <div class="info_item" v-for="(item,index) in salesTransactionInfo.channelAccounts.slice(0,accountsNum)">
                <div class="left_box">
                  <img :src="item.icon">
                </div>
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                  <div class="right_infos">
                    <div>{{ item.name }}</div>
                    <div>code：{{ item.code }}</div>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="box_infos">
        <div class="chang_box_info_case">
          <div class="chang_box_content" v-if="statisticalUserInfo.register">
            <div class="chin_box_title" style="margin-right: 20px">
              <div class="div_name">用户信息</div>
              <div class="box_info_tabs">
                <div class="box_name_tabs">
                  <div>注册</div>
                  <div class="content_box">{{ statisticalUserInfo.register.total }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近30天</div>
                  <div class="content_box">{{ statisticalUserInfo.register.month }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近15天</div>
                  <div class="content_box">{{ statisticalUserInfo.register.month15 }}</div>
                </div>
                <div class="box_name_tabs" style="margin-right: 0">
                  <div>今日</div>
                  <div class="content_box">{{ statisticalUserInfo.register.day }}</div>
                </div>
              </div>
            </div>
            <div class="chin_box_title">
              <div class="div_name">会员信息</div>
              <div class="box_info_tabs">
                <div class="box_name_tabs">
                  <div>购买</div>
                  <div class="content_box">{{ statisticalUserInfo.vip.total }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近30天</div>
                  <div class="content_box">{{ statisticalUserInfo.vip.month }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近15天</div>
                  <div class="content_box">{{ statisticalUserInfo.vip.month15 }}</div>
                </div>
                <div class="box_name_tabs" style="margin-right: 0">
                  <div>今日</div>
                  <div class="content_box">{{ statisticalUserInfo.vip.day }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="cakeBox">
            <div class="pie_car">
              <pie-chart v-if="ageShow" :report="age"></pie-chart>
            </div>
            <div class="pie_car">
              <pie-chart v-if="sexShow" :report="sex"></pie-chart>
            </div>
            <div class="pie_car">
              <pie-chart v-if="equipmentShow" :report="equipment"></pie-chart>
            </div>
            <div class="pie_car" style="margin-right: 0">
              <pie-chart v-if="regionShow" :report="region"></pie-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ColumnChart from "./components/ColumnChart";
import CurveChart from "./components/CurveChart";
import pieChart from "./components/pieChart";

export default {
  name: "logHome",
  components: {ColumnChart, CurveChart, pieChart},
  data() {
    return {
      loading: false,
      salesTransaction: {},
      salesDayTransaction: {},
      salesTransactionInfo: {},
      channeTransaction: {},
      numberShow: false,
      payShow: false,
      channeShow: false,
      info: {},
      changAppNum: 10,
      accountsNum: 10,
      options: [
        {
          value: 7,
          label: '近7天'
        }, {
          value: 15,
          label: '近15天'
        }, {
          value: 30,
          label: '近30天'
        }
      ],
      sucsLimit: 15,
      moneyLimit: 15,
      channeLimit: 15,
      loadingnNumberShow: false,
      loadingnPayShow: false,
      loadingnChanneShow: false,
      channelData: [],
      channelAccountId: 0,
      activeTypeNum: 1,
      bizType: 'exam',
      statisticalUserInfo: {},
      age: {},
      ageShow: false,
      sex: {},
      sexShow: false,
      equipment: {},
      equipmentShow: false,
      region: {},
      regionShow: false,
      channelInfo: {},
      channelAge: {},
      channelAgeShow: false,
      channelSex: {},
      channelSexShow: false,
      channelEquipment: {},
      channelEquipmentShow: false,
      channelRegion: {},
      channelRegionShow: false,
      channelPieAccountId: 0,
      loadinChannel: false,
    }
  },
  mounted() {
    // this.getPayList()
    this.getPaySucsList()
    this.maneyInfd()
    this.channelList()
    this.statisticalUser()
    this.channelOrderFlux()
  },
  computed: {
    getViewPortHeight() {
      return document.documentElement.clientWidth || document.body.clientWidth;
    }
  },
  methods: {
    async channelList() {
      const {data: resData} = await this.$get("channel/account/list?paging=false", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      this.channelData = resData.data;
      this.channelAccountId = resData.data[0].channelAccountId
    },

    async statisticalUser() {
      const {data: resData} = await this.$get("/console/stats/user/info");
      if (resData.result != 200) {
        return;
      }
      this.statisticalUserInfo = resData.data

      let ageObj = {
        id: 'userAge',
        name: '用户年龄',
        data: resData.data.age.data,
        width: '230px',
        height: '230px'
      }
      this.age = ageObj
      this.ageShow = true
      let sexObj = {
        id: 'userSex',
        name: '用户性别',
        data: resData.data.sex.data,
        width: '230px',
        height: '230px'
      }
      this.sex = sexObj
      this.sexShow = true
      let equipmentObj = {
        id: 'userEquipment',
        name: '使用设备',
        data: resData.data.device.data,
        width: '230px',
        height: '230px'
      }
      this.equipment = equipmentObj
      this.equipmentShow = true
      let regionObj = {
        id: 'useRegion',
        name: '地域分布 * 前十名',
        data: resData.data.district.data,
        width: '230px',
        height: '230px'
      }
      this.region = regionObj
      this.regionShow = true
    },

    async channelOrderFlux() {
      this.loadinChannel = true
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = "/console/stats/channel/order/flux?channelAccountId=" + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = "/console/stats/channel/order/flux?bizType=" + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadinChannel = false
        return;
      }
      this.loadinChannel = false
      this.channelInfo = resData.data
      let arrName = ''
      if(this.bizType=='exam'){
        arrName = '用户年龄'
      }else if(this.bizType=='znqm'){
        arrName = '宝宝性别'
      }else if(this.bizType=='taluo'){
        arrName = '年龄区间'
      }
      let channelAgeObj = {
        id: 'channelAge',
        name: arrName,
        data: resData.data.age.data,
        width: '230px',
        height: '230px'
      }
      this.channelAge = channelAgeObj
      this.channelAgeShow = true
      let channelSexObj = {
        id: 'channelSex',
        name: '用户性别',
        data: resData.data.sex.data,
        width: '230px',
        height: '230px'
      }
      this.channelSex = channelSexObj
      this.channelSexShow = true
      let channelEquipmentObj = {
        id: 'channelEquipment',
        name: '使用设备',
        data: resData.data.device.data,
        width: '230px',
        height: '230px'
      }
      this.channelEquipment = channelEquipmentObj
      this.channelEquipmentShow = true
      let channelRegionObj = {
        id: 'channelRegion',
        name: '地域分布 * 前十名',
        data: resData.data.district.data,
        width: '230px',
        height: '230px'
      }
      this.channelRegion = channelRegionObj
      this.channelRegionShow = true
      // this.loadinChannel = false
    },

    channelOrderFluxClick() {
      this.channelAgeShow = false
      this.channelSexShow = false
      this.channelEquipmentShow = false
      this.channelRegionShow = false
      this.channelOrderFlux()
      if (this.activeTypeNum == 1) {
        this.numberShow = false
        this.getPaySucsList()
      } else if (this.activeTypeNum == 2) {
        this.payShow = false
        this.getPayList()
      } else {
        this.channeShow = false
        this.getChannelList()
      }
    },


    goInfo() {
      this.$router.push({
        name: 'INFO',
        query: {
          title: '版本详情',
          value: this.salesTransactionInfo.sysver.sysverId,
        }
      })
    },

    changNums() {
      if (this.changAppNum == this.salesTransactionInfo.appInfos.length) {
        this.changAppNum = 10
      } else {
        this.changAppNum = this.salesTransactionInfo.appInfos.length
      }
    },

    changSceNums() {
      if (this.accountsNum == this.salesTransactionInfo.channelAccounts.length) {
        this.accountsNum = 10
      } else {
        this.accountsNum = this.salesTransactionInfo.channelAccounts.length
      }
    },

    async getPaySucsList() {
      this.loadingnNumberShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/order/pay/sucs?limit=' + this.sucsLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/order/pay/sucs?limit=' + this.sucsLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadingnNumberShow = false;
        return;
      }
      let obj = {
        id: 'myTransactionChart',
        name: '支付数量（近' + this.sucsLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.salesTransaction = obj
      this.numberShow = true
      this.loadingnNumberShow = false;
    },

    async getPayList() {
      this.loadingnPayShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/order/pay/moneys?limit=' + this.moneyLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/order/pay/moneys?limit=' + this.moneyLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);

      if (resData.result != 200) {
        this.loadingnPayShow = false;
        return;
      }
      let obj = {
        id: 'myDayTransactionChart',
        name: '支付金额（近' + this.moneyLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.salesDayTransaction = obj
      this.payShow = true
      this.loadingnPayShow = false;
    },

    async getChannelList() {
      this.loadingnChanneShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/channel/adput/flux?limit=' + this.channeLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/channel/adput/flux?limit=' + this.channeLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadingnChanneShow = false;
        return;
      }
      let obj = {
        id: 'myChanneTransactionChart',
        name: '渠道流量（近' + this.channeLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.channeTransaction = obj
      this.channeShow = true
      this.loadingnChanneShow = false;
    },

    async maneyInfd() {
      this.loading = true;
      const {data: resData} = await this.$get("/console/info");
      this.loading = false;
      if (resData.result != 200) return;
      this.salesTransactionInfo = resData.data
      this.info = resData.data.info;
    },

    changActiveItem(e) {
      this.activeTypeNum = e
      if (e == 1) {
        this.numberShow = false
        this.getPaySucsList()
      } else if (e == 2) {
        this.payShow = false
        this.getPayList()
      } else {
        this.channeShow = false
        this.getChannelList()
      }
    },
    changActiveModeItem(e) {
      this.bizType = e

      this.sucsLimit = 15
      this.moneyLimit = 15
      this.channeLimit = 15
          this.channelPieAccountId = 0
      this.channelOrderFluxClick()
    },

    moneyNumChang(e) {
      this.payShow = false
      this.getPayList()
    },

    sucsNumChang() {
      this.numberShow = false
      this.getPaySucsList()
    },

    channeNumChang() {
      this.channeShow = false
      this.getChannelList()
    },
  }
}
</script>

<style scoped lang="scss">
.icon_infos {
  cursor: pointer;
  width: 100%;
  position: relative;
  display: flex;

  .info_lefts {
    width: 392px;
    margin-right: 20px;

    .item_box {
      padding: 10px;
      border: 1px solid rgba(215, 215, 215, 1);
      margin-bottom: 20px;
      border-radius: 4px;
      font-size: 14px;

      .name_tabs {

      }

      .bor_yas {
        padding: 2px 5px;
        border-radius: 4px;
        background: #3a8ee6;
        color: #ffffff;
        margin-left: 5px;
      }

      .nowMore {
        i {
          transform: rotate(0deg);
          transition: all 0.3s linear;
        }
      }

      .active_box {
        i {
          transition: all 0.3s linear;
          transform: rotate(90deg);
        }
      }
    }

    .info_list_tabs {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 15px;

      .info_item {
        display: flex;
        padding: 5px;
        width: 170px;
        background: rgba(242, 242, 242, 1);
        margin-right: 10px;
        margin-bottom: 10px;

        .left_box {
          width: 40px;
          height: 40px;
          margin-right: 10px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }

        .right_infos {
          width: 95px;

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .info_item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  .box_infos {
    margin-bottom: 10px;
    width: calc(100% - 420px);
  }

  .active_Info_name {
    display: flex;
    align-items: center;

    .top_head {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .box_info_infos {
      div:nth-child(1) {
        margin-bottom: 5px;
      }

      div:nth-child(2) {
        font-size: 12px;
        color: #959595;
      }
    }
  }

  .pay_number {
    min-height: 680px;
  }

  .chineac_box {
    display: flex;
    align-items: center;
    height: 35px;
    width: 450px;
    border-bottom: 1px solid rgba(242, 242, 242, 1);
    margin-bottom: 20px;

    div {
      height: 35px;
      line-height: 35px;
      width: 150px;
      text-align: center;
      font-size: 14px;
      border-radius: 4px 4px 0 0;
    }

    .active_div {
      background-color: rgba(242, 242, 242, 1);
    }
  }

  .chang_box_content {
    display: flex;
    flex-wrap: wrap;

    .chin_box_title {
      padding: 15px;
      border: 1px solid rgba(215, 215, 215, 1);
      border-radius: 4px;
      margin-bottom: 20px;

      .div_name {
        font-size: 13px;
        margin-bottom: 10px;
      }

      .box_info_tabs {

        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .box_name_tabs {
          padding: 10px;
          min-width: 98px;
          background: rgba(242, 242, 242, 1);
          text-align: center;
          margin-right: 20px;
          border-radius: 4px;
          div {
            font-size: 12px;
          }

          .content_box {
            margin-top: 5px;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
    }
  }

  .pie_car {
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 3px;
    width: 230px;
    height: 240px;
    padding: 0 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .cakeBox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .line {
    width: 94%;
    height: 0;
    border-bottom: 1px solid rgba(215, 215, 215, 1);
    margin-bottom: 40px;
  }

  .clasdsad_infasas {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .Rate_num {
      font-size: 12px;
      font-weight: 400;
    }
  }

}

.info_tans_congdsd{
  font-family: Xiaozhuan;
  font-size: 50px;
}

</style>